/* eslint-disable react/display-name */
import React, { forwardRef, memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-simple-select/dist/index.module.css';
const SimpleSelectTrigger = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id = '',
    setIsMenuOpen,
    isMenuOpen,
    children,
    className = ''
  } = props;
  const triggerElt = children(isMenuOpen, setIsMenuOpen);
  const triggerClassName = classNames({
    [styles['sib-simple-select__trigger-wrapper']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: triggerClassName
  }, /*#__PURE__*/React.cloneElement(triggerElt, {
    'aria-expanded': isMenuOpen,
    'aria-haspopup': 'listbox',
    'aria-disabled': triggerElt?.props?.disabled,
    'aria-controls': `${id}__menu`,
    id: triggerElt?.props?.id || `${id}__trigger`
  }));
});
export default /*#__PURE__*/memo(SimpleSelectTrigger);
SimpleSelectTrigger.propTypes = {
  setIsMenuOpen: PropTypes.func,
  isMenuOpen: PropTypes.bool,
  id: PropTypes.string,
  children: PropTypes.func.isRequired,
  className: PropTypes.string
};